import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Element UI
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Pinia
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

// Sentry
import * as Sentry from "@sentry/vue";

// Vant
import Vant from 'vant';
import 'vant/lib/index.css';

// Global language
import { setupI18n } from "./language/index";
import { useLanguageStore } from "./stores/language";

// Axios
import { driverAxios, merchantAxios, commonAxios } from "./stores/axios";

// Vant Toast
import customToast from "./plugins/toast";

// VConsole
import VConsole from 'vconsole';

// FCM
import { requestPermission } from "./stores/firebase";

const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(router)
app.use(ElementPlus)
app.use(Vant)

const languageStore = useLanguageStore(); // 确保 Pinia 已激活
const i18n = setupI18n(languageStore); // 初始化 i18n
languageStore.initLocale();
app.use(i18n);

console.log(import.meta.env.MODE)
if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'beta') {
  new VConsole(); 
}

if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  Sentry.init({
    app,
    dsn: "https://299ed9419dc9563652bd5ad93b22e6bd@o1240499.ingest.us.sentry.io/4508411010416641",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data,
        // or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask', and 'maskFn'.
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [window.location.origin],
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/xixi-5s\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

// **拦截所有 JS、CSS、图片等静态资源请求，并禁用缓存**
const disableCache = () => {
  if ("caches" in window) {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  }

  const noCacheHeaders = new Headers({
    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
    "Pragma": "no-cache",
    "Expires": "0"
  });

  const originalFetch = window.fetch;
  window.fetch = function (url, options = {}) {
    if (url.includes(".js") || url.includes(".css") || url.includes(".png") || url.includes(".jpg") || url.includes(".jpeg") || url.includes(".svg") || url.includes(".gif")) {
      options.headers = new Headers({ ...(options.headers || {}), ...noCacheHeaders });
      options.cache = "no-store";
    }
    return originalFetch(url, options);
  };

  console.log("禁用了 JS、CSS、图片等静态资源的缓存");
};

disableCache();

// **保留 Firebase Service Worker**
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/firebase-messaging-sw.js")
    .then((registration) => console.log("🔥 Firebase Service Worker 注册成功:", registration))
    .catch((err) => console.log("❌ Firebase Service Worker 注册失败:", err));
}

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then((registrations) => {
//     registrations.forEach((registration) => {
//       registration.unregister();
//     });
//   });
// }

requestPermission();

app.config.globalProperties.$driverAxios = driverAxios;
app.config.globalProperties.$merchantAxios = merchantAxios;
app.config.globalProperties.$commonAxios = commonAxios;

app.config.globalProperties.$toast = customToast;

app.mount('#app')
